<app-banner [imageUrl]="imagenPrueba" [tickerItems]="listaCinta" (actionClick)="handleBannerButtonClick()"></app-banner>
<app-ui-loading *ngIf="loading()"></app-ui-loading>

<app-product-carousel-section
    [title]="'Enviar flores, regalos y plantas a domicilio en Puno es muy fácil con Undetalle'"
    [products]="listaProductos()" [viewAllUrl]="viewAllUrl"></app-product-carousel-section>

<app-category-carousel-section
    [title]="'Aquí no se “envía” un regalo, se entrega una emoción. Por eso trabajamos con puntualidad, cuidado y confirmación de entrega. 💐🚚'"
    [titleSide]="'PARA CADA OCASIÓN, UN REGALO ESPECIAL'"
    [description]="'«Flores frescas y diseños únicos para cada momento».'"
    [categories]="misCategorias()"></app-category-carousel-section>

<app-product-carousel-section
    [title]="'Tú solo elige el detalle. Nosotros nos encargamos del resto.En Undetalle cuidamos cada pedido como si fuera nuestro.'"
    [products]="listaProductos()" [viewAllUrl]="viewAllUrl"></app-product-carousel-section>

<app-category-carousel-section
    [title]="'Cuando regalas a distancia, lo más importante es la tranquilidad. Nosotros te la damos con un proceso seguro y comunicación constante.'"
    [categories]="misCategorias()"></app-category-carousel-section>

<app-about-features-banner></app-about-features-banner>